import {Component, Inject, OnInit} from '@angular/core';
import {FormControl, FormGroup, NgForm, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {CustomerAddress} from "../../../../models/CustomerInfo/CustomerAddress";
import {MagentoCustomerService} from "../../../../../../services/magentocustomer.service";
import {RegistryService} from "../../../../services/registry.service";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {CheckoutShippingAddressComponent} from "../checkout-shipping-address.component";
import {environment} from "../../../../../../environments/environment";


@Component({
    selector: 'app-new-shipping-address',
    templateUrl: './new-shipping-address.component.html',
    styleUrls: ['./new-shipping-address.component.css']
})

export class NewShippingAddressComponent implements OnInit {

    id: string;

    isHidden: boolean;
    checkedRoles: number[] = [];

    public href = '';

    title = 'Shipping Address';
    searchText: any;

    form = new FormGroup({
        first_name: new FormControl('', Validators.required),
        last_name: new FormControl('', Validators.required),
        city: new FormControl('' , Validators.required),
        street: new FormControl('' ,Validators.required),
        phone: new FormControl('', [Validators.pattern('^[0-9]*$'), Validators.required]),
    });

    constructor(private router: Router,
                private customerService: MagentoCustomerService,
                private route: ActivatedRoute,
                private registry: RegistryService,
                private dialogRef: MatDialogRef<NewShippingAddressComponent>,
                @Inject(MAT_DIALOG_DATA) public data: any
    ) {


    }


    ngOnInit() {

        this.id = this.data.id;

    }


    add_update() {

        if (parseInt(this.id) === -1) {
            this.createAddress();
        } else {
            this.updateAddress();
        }

    }

    close() {

        this.dialogRef.close();
    }

    // for create a new user
    createAddress() {

        let new_address = new CustomerAddress();
        new_address.firstname = this.form.value.first_name;
        new_address.lastname = this.form.value.last_name;
        new_address.city = this.form.value.city;
        new_address.street = [this.form.value.street];
        new_address.telephone = this.form.value.phone;
        new_address.country_id = environment.defaultCountry;
        new_address.id = null;

        let customer = this.registry.customer;
        customer.websiteId = this.registry.getWebsiteId();

        customer.addresses.push(new_address);
        this.customerService.updateCustomerData(customer).subscribe(result => {

            this.customerService.getCustomerInfo().subscribe(customer =>{

                this.registry.customer = customer;
                this.registry.EmitCustomerLoaded(customer);
                this.data.parent.setAddressSelected(customer.addresses[customer.addresses.length-1]);
                this.form.reset();
                this.dialogRef.close();
            })

        });


    }

    // for updating user
    updateAddress() {

        let new_address = new CustomerAddress();
        new_address.firstname = this.form.value.first_name;
        new_address.lastname = this.form.value.last_name;
        new_address.city = this.form.value.city;
        new_address.street = this.form.value.street;
        new_address.telephone = this.form.value.phone;
        // new_address.id =
        let customer = this.registry.customer;

        for (let i = 0; i < customer.addresses.length;) {

            if (customer.addresses[i].id == new_address.id) {
                customer.addresses[i] = new_address;

            }

        }

        this.customerService.updateCustomerData(customer).subscribe(result => {

            //reload parent and set new address as selected selected.
            this.registry.customer = customer;
        });
    }


}
